
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/tos",
      function () {
        return require("private-next-pages/en/tos/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/tos"])
      });
    }
  